import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Chip,
  Paper,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import * as XLSX from "xlsx";
import {
  NoDataFoundRow,
  StyledTableCell,
  StyledTableRow,
} from "../../../components/common/StyledTableComponents";
import { useDispatch, useSelector } from "react-redux";
import { getdeleteduserslistApi } from "../../../features/Admin/Reports/AdminReports";
import dayjs from "dayjs";
import Loader from "../../../components/common/Loader/Loader";
import NormalDatePicker from "../../../components/common/NormalDatePicker";
import CustomSearchField from "../../../components/common/CustomSearchField";
import { debounce, set } from "lodash";
import ExportToExcelButton from "../../../components/common/ExportToExcelButton";
import RefreshButton from "../../../components/common/RefreshButton";
import { notifyError, notifySuccess } from "../../../utils/notificationMsg";
import {
  PayOutApi,
  RecruiterPaymentApi,
} from "../../../features/Admin/AdminPayout/AdminPayoutAPI";
import RefreshIcon from "@mui/icons-material/Refresh";

import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import AdminControl from "../../../components/common/AdminControl";
import { formatUSAmount } from "../../../utils/helpers";
import CustomPagination from "../../../components/common/CustomPagination";
import SelectFieldforAdminSettings from "../Setting/SelectFieldforAdminSettings";
const AdminPayoutDetails = () => {
  const dispatch = useDispatch();
      const today = localStorage.getItem('serverTime') ? new Date(localStorage.getItem('serverTime')) :new Date();
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(
    dayjs(today).subtract(1, "year").toDate()
  );
  const [toDate, setToDate] = useState(dayjs(today).toDate());
  const [lodaing, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [Count, setCount] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [loadingOnline, setLoadingOnline] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedValue, setSelectedValue] = useState("");

  const onClose = () => {
    setIsModalOpen(false);
    setSelectedValue("");
  };

  const handleSubmit = () => {
    setIsModalOpen(true);
  };

  const handlePayment = async (method) => {
    setLoading(true);
    setPaymentMethod(method);
    const selectedIdsString = selectedIds.join(", ");
    let data = {
      candidate_id: selectedIdsString,
      payment_method: method,
    };
    try {
      const { payload } = await dispatch(RecruiterPaymentApi(data));
      console.log(payload);
      if (payload.status === 200) {
        notifySuccess(payload.message);
        GetPayOutDetails();
        setIsModalOpen(false);
        setSelectedValue("");
      } else {
        notifyError(payload.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const isStripeDisabled = selectedIds.some(
    (id) => !data.find((row) => row?._id?.$oid === id)?.connect_status
  );

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevIds) => {
      if (prevIds.includes(id)) {
        return prevIds.filter((prevId) => prevId !== id);
      } else {
        return [...prevIds, id];
      }
    });
  };

  const handleHeaderCheckboxChange = (event) => {
    if (event.target.checked) {
      // Select all rows where connect_status === true
      const newSelectedIds = data // Only rows with connect_status === true
        .map((row) => row?._id?.$oid); // Extract their IDs
      setSelectedIds(newSelectedIds);
    } else {
      // Deselect all rows
      setSelectedIds([]);
    }
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "Invalid Date"; // Handle case where dateString is undefined or invalid
    }

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Handle invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  const GetPayOutDetails = async (
    query = "",
    pageNum = 1,
    startDate = fromDate,
    endDate = toDate,
    pageSize = rowsPerPage
  ) => {
    setSelectedIds([]);
    setLoading(true);
    let data = {
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      pagenumber: pageNum,
      export: false,
      searchitem: query.trim(),
      pagesize: pageSize,
    };
    try {
      const { payload } = await dispatch(PayOutApi(data));
      if (payload.status === 200) {
        let data = payload.data || [];
        setData(data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const RecruiterPayment = async () => {
    setLoading(true);
    const selectedIdsString = selectedIds.join(", ");
    let data = {
      candidate_id: selectedIdsString,
    };
    // try {
    //   const { payload } = await dispatch(RecruiterPaymentApi(data));
    //   console.log(payload);
    //   if (payload.status === 200) {
    //     notifySuccess(payload.message);
    //     GetPayOutDetails();
    //   } else {
    //     notifyError(payload.message);
    //   }
    // } catch (err) {
    //   console.error(err);
    // } finally {
    //   setLoading(false);
    // }
  };

  const GetPayOutDetailsReset = async () => {
    setLoading(true);
    let from = dayjs().subtract(1, "year").toDate();
    let to = dayjs().toDate();
    setFromDate(from);
    setToDate(to);
    setSearchQuery("");
    setPage(1);
    setRowsPerPage(10);
    setSelectedIds([]);
    let data = {
      fromDate: formatDate(from),
      toDate: formatDate(to),
    };
    try {
      const { payload } = await dispatch(PayOutApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetPayOutDetails();
  }, []);

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setPage(1);
    setRowsPerPage(newRowsPerPage);
    GetPayOutDetails(searchQuery, 1, fromDate, toDate, newRowsPerPage);
  };
  const handlePageChange = (value) => {
    setPage(value);
    GetPayOutDetails(searchQuery, value, fromDate, toDate, rowsPerPage);
  };

  const debouncedSearch = useCallback(
    debounce((query, page, updatedFrom, updatedTo) => {
      GetPayOutDetails(query, page, updatedFrom, updatedTo);
    }, 1300),
    []
  );
  useEffect(() => {
    setPage(1);
    debouncedSearch(searchQuery, 1, fromDate, toDate);
  }, [searchQuery]);

  const paymentOptions = [
    { label: "Bank Transfer", value: "bank transfer", disabled: false },
    { label: "Electronic Check", value: "electronic check", disabled: false },
    { label: "Stripe", value: "stripe", disabled: isStripeDisabled },
  ];

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <>
      <AdminControl
        title={"Payout to Recruiters"}
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        GetFunction={GetPayOutDetails}
        ResetFunction={GetPayOutDetailsReset}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        isSubmit={true}
        handleSubmit={handleSubmit}
        selectedIds={selectedIds}
      />
      {lodaing ? (
        <Loader />
      ) : (
        <Box>
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#ECF1FF" }}>
                  <StyledTableCell>
                    <Checkbox
                      checked={
                        data &&
                        data.length > 0 &&
                        data.every((row) =>
                          selectedIds.includes(row?._id?.$oid)
                        )
                      }
                      onChange={handleHeaderCheckboxChange}
                      indeterminate={
                        data &&
                        data.some(
                          (row) =>
                            row.connect_status &&
                            !selectedIds.includes(row?._id?.$oid)
                        ) &&
                        data.some(
                          (row) =>
                            row.connect_status &&
                            selectedIds.includes(row?._id?.$oid)
                        )
                      }
                    />
                  </StyledTableCell>
                  <StyledTableCell>No.</StyledTableCell>
                  <StyledTableCell>Name of Candidate</StyledTableCell>
                  <StyledTableCell>Name of Client</StyledTableCell>
                  <StyledTableCell>Name of Recruiter</StyledTableCell>
                  <StyledTableCell>Recruiter Status</StyledTableCell>
                  <StyledTableCell>Candidate Hired Amount</StyledTableCell>
                  <StyledTableCell>Admin Commission</StyledTableCell>
                  <StyledTableCell>Recruiter Commission</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  data.map((row, index) => {
                    let ids = row?._id.$oid;
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        <StyledTableRow sx={{ textAlign: "center" }}>
                          <Checkbox
                            checked={selectedIds.includes(ids)}
                            onChange={() =>
                              handleCheckboxChange(ids, row.connect_status)
                            }
                          />
                        </StyledTableRow>

                        <StyledTableRow sx={{ textAlign: "center" }}>
                          {row.serialnumber}.
                        </StyledTableRow>

                        <StyledTableRow>{`${row.candidate_firstname} ${row.candidate_lastname}`}</StyledTableRow>
                        <StyledTableRow>{row.client_name}</StyledTableRow>
                        <StyledTableRow>{row.recruiter_name}</StyledTableRow>
                        <StyledTableRow>
                          <Chip
                            label={row.connect_status ? "Complete" : "Pending"}
                            color={row.connect_status ? "success" : "warning"}
                            sx={{
                              borderRadius: "5px",
                              fontSize: "12px",
                              fontFamily: "Urbane-Light",
                            }}
                          />
                        </StyledTableRow>
                        <StyledTableRow
                          sx={{ minWidth: "130px" }}
                          align="right"
                        >
                          {formatUSAmount(row.candidate_totalamount)}
                        </StyledTableRow>
                        <StyledTableRow
                          sx={{ minWidth: "130px" }}
                          align="right"
                        >
                          {formatUSAmount(row.admin_commission)}
                        </StyledTableRow>
                        <StyledTableRow
                          sx={{ minWidth: "130px" }}
                          align="right"
                        >
                          {formatUSAmount(row.recruiter_commissionamount)}
                        </StyledTableRow>
                      </TableRow>
                    );
                  })
                ) : (
                  <NoDataFoundRow
                    colSpan={9}
                    message={`Payout Details Are Not Available!`}
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <CustomPagination
            totalRecords={Count}
            rowsPerPageOptions={[10, 25, 50, 100]}
            initialRowsPerPage={rowsPerPage}
            setRowsPerPage1={setRowsPerPage}
            initialPage={page - 1}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Box>
      )}

      <Dialog
        open={isModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            onClose();
          }
        }}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "17px",
            maxWidth: "450px",
          },
        }}
      >
        <DialogTitle sx={{ padding: 0, borderRadius: "25%" }}>
          <Box
            sx={{
              backgroundColor: "#250258",
              padding: "12px 16px",
              position: "relative",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "white",
                fontFamily: "Urbane-Light",
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
              Recruiter Payment Details{" "}
            </Typography>
            <IconButton
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{
            m: 1,
          }}
        >
          <Paper elevation={1} sx={{ padding: 8, textAlign: "center" }}>
            <Typography variant="subtitle1" gutterBottom>
              To complete the payment process, please choose one of the
              following options:
            </Typography>
            {/* <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handlePayment("stripe")}
                  disabled={isStripeDisabled}
                  sx={{
                    backgroundColor: "#250258",
                    color: "#fff",
                    "&.Mui-disabled": {
                      backgroundColor: "#d3d3d3", // Set the disabled background color
                      color: "#a1a1a1", // Set the disabled text color
                    },
                  }}
                >
                  Pay With Stripe
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => handlePayment("cash")}
                  style={{ backgroundColor: "#dc3545" }}
                  disabled={loadingOnline}
                >
                  Pay With Cash
                </Button>
              </Grid>
            </Grid> */}
            <br />
            <SelectFieldforAdminSettings
              label="Select Payment Method"
              options={paymentOptions}
              placeholder="Select an option"
              value={selectedValue}
              onChange={handleSelectChange}
              isRequired={true}
            />

            <Button
              variant="contained"
              color="primary"
              onClick={() => handlePayment(selectedValue)}
              disabled={lodaing || !selectedValue}
              sx={{
                mt: 2,
                backgroundColor: "#250258",
                color: "#fff",
                "&.Mui-disabled": {
                  backgroundColor: "#d3d3d3", // Set the disabled background color
                  color: "#a1a1a1", // Set the disabled text color
                },
              }}
            >
              Proceed with Payment
            </Button>
            {isStripeDisabled && (
              <Typography variant="body2" color="error">
                The Stripe button is disabled because some recruiters don’t have
                an active Stripe account connected.
              </Typography>
            )}
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AdminPayoutDetails;
